import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { WaitingListLinkOnly } from './WaitingListLinkOnly';
import { WalkInList } from '../../../../modules/shared/appointments/walk-in-list';
import { WalkInListLinkOnly } from './WalkInListLinkOnly';
import { WaitingListsDropdown } from './WaitingListsDropdown';
export var WaitingListLink = function (_a) {
    var canSeeWaitingList = _a.canSeeWaitingList, canSeeWalkInList = _a.canSeeWalkInList, walkInListOpenIsOn = _a.walkInListOpenIsOn, walkInListOpenOn = _a.walkInListOpenOn, walkInListOpenOff = _a.walkInListOpenOff, customersWaiting = _a.customersWaiting, date = _a.date;
    if (!canSeeWaitingList && !canSeeWalkInList) {
        return null;
    }
    if (!canSeeWalkInList) {
        return (_jsx(WaitingListLinkOnly, { className: "c-btn c-btn--medium c-btn--ghost u-ml-", customersWaiting: customersWaiting, date: date }));
    }
    var walkInListModal = walkInListOpenIsOn ? _jsx(WalkInList, { onClose: walkInListOpenOff }) : null;
    if (!canSeeWaitingList) {
        return (_jsxs(_Fragment, { children: [_jsx(WalkInListLinkOnly, { onOpenWalkInList: walkInListOpenOn }), walkInListModal] }));
    }
    return (_jsxs(_Fragment, { children: [_jsx(WaitingListsDropdown, { customersWaiting: customersWaiting, date: date, onOpenWalkInList: walkInListOpenOn }), walkInListModal] }));
};
export default WaitingListLink;
